import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const ProductLinkColorSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='35' height='34' viewBox='0 0 35 34' fill='none'>
    <g clipPath='url(#clip0_333_14259)'>
      <path
        d='M0.915527 26.0402C1.0816 25.0649 1.36559 24.1294 1.88624 23.2779C2.22115 22.7309 2.62006 22.2258 3.07452 21.7733C5.65922 19.1862 8.24448 16.5989 10.8303 14.0113C12.4304 12.4087 14.3602 11.656 16.6164 11.8346C18.317 11.9692 19.7826 12.6787 20.9991 13.875C21.2673 14.137 21.4238 14.4926 21.4357 14.8674C21.4476 15.2422 21.3141 15.607 21.0631 15.8855C20.5217 16.4804 19.6764 16.5443 19.0386 16.0052C18.6234 15.6546 18.2082 15.3139 17.71 15.0846C16.2286 14.4034 14.3735 14.6576 13.2019 15.7925C11.512 17.43 9.8629 19.1098 8.19798 20.7772C7.12762 21.8464 6.03898 22.9015 4.9927 23.9932C2.93086 26.1424 3.59351 29.5395 6.29807 30.7757C7.74625 31.4404 9.60049 31.1745 10.7506 30.0712C12.1215 28.7553 13.4485 27.3944 14.7945 26.0527C15.1267 25.7204 15.4846 25.477 15.982 25.4861C16.5541 25.4969 16.9784 25.7437 17.2566 26.2338C17.5348 26.724 17.4974 27.2308 17.2018 27.711C17.1569 27.7874 17.1034 27.8585 17.0424 27.9228C15.5709 29.3875 14.1502 30.9062 12.6156 32.3061C11.5951 33.2382 10.3644 33.7641 8.99514 33.9618C8.95238 33.9718 8.91045 33.9852 8.86976 34.0017H7.07945C7.01634 33.9851 6.95324 33.9651 6.8893 33.9535C4.73529 33.5797 3.07646 32.4669 1.91282 30.6154C1.37473 29.7613 1.0924 28.8159 0.916359 27.8323L0.915527 26.0402Z'
        fill='url(#paint0_linear_333_14259)'
      />
      <path
        d='M23.1264 34C22.394 33.6818 22.0768 33.1385 22.0993 32.3276C22.135 31.0158 22.1067 29.7023 22.11 28.3889C22.11 27.5315 22.7262 26.8868 23.535 26.8851C24.3438 26.8835 24.9915 27.5149 24.9981 28.3656C25.0086 29.7674 25.0086 31.1687 24.9981 32.5694C24.9915 33.2996 24.5829 33.7516 23.9186 34H23.1264Z'
        fill='url(#paint1_linear_333_14259)'
      />
      <path
        d='M0.915527 10.9822C1.1962 10.2237 1.73927 9.88478 2.54723 9.89641C3.88415 9.91552 5.22106 9.89641 6.55798 9.90472C6.86521 9.90147 7.16546 9.99642 7.41503 10.1757C7.66459 10.355 7.85045 10.6094 7.94554 10.9017C8.04193 11.1748 8.05205 11.471 7.97451 11.7501C7.89697 12.0292 7.73554 12.2777 7.51208 12.4619C7.27055 12.6778 6.95825 12.7975 6.63437 12.7983C5.17622 12.7983 3.71724 12.805 2.25909 12.7983C1.57236 12.7934 1.17959 12.3638 0.915527 11.7848V10.9822Z'
        fill='url(#paint2_linear_333_14259)'
      />
      <path
        d='M18.9715 23.0169C17.0616 23.0103 15.4199 22.3257 14.0348 21.018C13.4328 20.449 13.383 19.5451 13.9061 18.9585C14.4525 18.3462 15.2962 18.2764 15.9505 18.8455C16.5791 19.3922 17.2468 19.8425 18.0713 20.0145C19.4738 20.3052 20.7535 20.0145 21.7881 19.0242C23.3467 17.537 24.8489 15.9901 26.3735 14.4673C27.8128 13.03 29.2505 11.5922 30.6865 10.1538C31.58 9.26378 32.014 8.1904 31.9885 6.9337C31.9478 5.02289 30.3892 3.26078 28.5059 2.97499C27.0312 2.75068 25.7823 3.18269 24.736 4.22948C23.2197 5.74484 21.7043 7.26075 20.1896 8.77722C19.8517 9.11618 19.4813 9.36292 18.9706 9.34963C18.7092 9.35338 18.452 9.28305 18.2288 9.14678C18.0056 9.0105 17.8255 8.81383 17.7093 8.57949C17.4386 8.08102 17.4809 7.57756 17.7923 7.10318C17.8801 6.97616 17.9805 6.85841 18.0921 6.75175C19.6228 5.21812 21.154 3.68615 22.6858 2.15584C24.2843 0.566538 26.2232 -0.187817 28.4594 0.0373262C31.0278 0.295701 32.9634 1.61582 34.1334 3.92458C35.5525 6.72351 35.0169 9.9154 32.7832 12.1751C29.8935 15.099 26.9871 18.0067 24.0642 20.8984C22.6318 22.3265 20.9278 23.0161 18.9715 23.0169Z'
        fill='url(#paint3_linear_333_14259)'
      />
      <path
        d='M5.16876 2.82056C5.55323 2.85628 5.90199 2.97758 6.181 3.25589C7.59265 4.66823 9.0126 6.07475 10.4159 7.49291C11.0072 8.09108 10.9972 8.97005 10.4326 9.54412C9.8679 10.1182 8.96859 10.1323 8.3566 9.52834C6.9444 8.13095 5.54022 6.72526 4.14407 5.31126C3.69235 4.85433 3.57775 4.30102 3.83019 3.69621C3.94618 3.43741 4.13395 3.21734 4.37122 3.06213C4.60849 2.90692 4.88529 2.82307 5.16876 2.82056Z'
        fill='url(#paint4_linear_333_14259)'
      />
      <path
        d='M32.0779 29.7581C32.0206 30.3678 31.7565 30.8381 31.1778 31.0873C30.599 31.3365 30.065 31.2186 29.6166 30.7974C29.0852 30.2989 28.5803 29.7713 28.0655 29.2563C27.1745 28.3657 26.2827 27.4775 25.3966 26.5828C24.9756 26.1582 24.8071 25.6523 25.0022 25.0683C25.1973 24.4842 25.6325 24.1469 26.2478 24.0713C26.4519 24.0442 26.6595 24.0652 26.854 24.1327C27.0485 24.2002 27.2245 24.3124 27.368 24.4601C28.8106 25.8918 30.2474 27.3291 31.6785 28.7719C31.945 29.0394 32.0472 29.3884 32.0779 29.7581Z'
        fill='url(#paint5_linear_333_14259)'
      />
      <path
        d='M13.6675 3.5583C13.6675 4.2761 13.6675 4.99473 13.6675 5.71253C13.6688 6.08682 13.5237 6.44678 13.2634 6.71561C13.0031 6.98443 12.6481 7.14084 12.2741 7.15146C11.5044 7.16973 10.8069 6.57655 10.7911 5.79727C10.7604 4.30601 10.7579 2.81391 10.7911 1.32265C10.8102 0.534228 11.5094 -0.0124304 12.3364 0.0158164C13.073 0.0415708 13.66 0.663831 13.665 1.43646C13.6717 2.14347 13.6675 2.85047 13.6675 3.5583Z'
        fill='url(#paint6_linear_333_14259)'
      />
      <path
        d='M31.3283 21.2391C32.0357 21.2391 32.7399 21.2391 33.4491 21.2391C34.2412 21.2441 34.8607 21.834 34.8831 22.5892C34.9047 23.4266 34.3309 24.1087 33.5246 24.122C32.0676 24.1463 30.6097 24.1463 29.151 24.122C28.3555 24.1095 27.7393 23.4282 27.7501 22.6456C27.7569 22.2651 27.9142 21.9028 28.1875 21.638C28.4608 21.3733 28.8279 21.2278 29.2083 21.2333C29.9149 21.2391 30.6216 21.2391 31.3283 21.2391Z'
        fill='url(#paint7_linear_333_14259)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_333_14259'
        x1='0.915527'
        y1='11.8088'
        x2='22.1928'
        y2='12.5594'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_333_14259'
        x1='22.0981'
        y1='26.8851'
        x2='25.1162'
        y2='26.9322'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_333_14259'
        x1='0.915527'
        y1='9.89612'
        x2='8.23353'
        y2='10.5794'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_333_14259'
        x1='13.5459'
        y1='-0.00170898'
        x2='35.7064'
        y2='0.783209'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_333_14259'
        x1='3.69873'
        y1='2.82056'
        x2='11.12'
        y2='3.10372'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_333_14259'
        x1='24.9214'
        y1='24.0598'
        x2='32.3401'
        y2='24.3428'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_333_14259'
        x1='10.7671'
        y1='0.0147705'
        x2='13.7788'
        y2='0.0614796'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_333_14259'
        x1='27.75'
        y1='21.2332'
        x2='35.0915'
        y2='21.9204'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <clipPath id='clip0_333_14259'>
        <rect width='34' height='34' fill='white' transform='translate(0.915527)' />
      </clipPath>
    </defs>
  </svg>
);

export const ProductLinkColorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ProductLinkColorSvg} {...props} />
);
